export class Filter {
    constructor(public property: string,
                public operator: string,
                public value: any = '') {
    }
}
